/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaPinterest,
//   FaTwitter,
// } from 'react-icons/fa'
import FooterOne from '../components/Footer'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Navbar from './Navbar'
import Breadcrumb from './Breadcrumb'
import DynamicLayout from './DynamicLayout'
// import { Link } from 'react-router-dom'

// eslint-disable-next-line react/prop-types

const TeamDetailsGroup = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  const [layoutConfig, setLayoutConfig] = useState(null)
  const maxSuite = t('max-suite', { returnObjects: true })
  const solution = maxSuite.find((solution) => solution.id == id)
  // eslint-disable-next-line no-unused-vars
  useEffect(() => {
    setLayoutConfig(solution)
    window.scrollTo(0, 0)
  }, [])
  return (
    <div>
      <Navbar />
      <Breadcrumb title={solution.title} />
      {layoutConfig && (
        <DynamicLayout
          title={solution.title}
          subtitle={solution.subtitle}
          slogan={solution.slogan}
          layout={solution.layout}
          content={solution.content}
        />
      )}

      <FooterOne />
      {/* ================= TeamDetailsGroup End =================*/}
    </div>
  )
}

export default TeamDetailsGroup
